module.exports = __webpack_public_path__ + "static/customIcons-5382dafd77756601589a891f9e94e287.gif";